import { formatTime } from 'legacyfrontend/utils/dateUtils';

export function isRichTextFilled(html) {
  return Boolean(
    String(html || '')
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .trim()
  );
}

export function cleanListContent(htmlContent) {
  return String(htmlContent || '')
    .replace(/<li[^>]*>\s*-\s*/g, '<li>')
    .replace(/<li[^>]*><span[^>]*>\s*-\s*/g, '<li><span>');
}

export function formatStopoverWait(waitingHours, waitingMinutes) {
  const hours = Math.min(23, Math.max(0, Number(waitingHours) || 0));
  const minutes = Math.min(59, Math.max(0, Number(waitingMinutes) || 0));
  return `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
}

export function extractTime(value) {
  if (!value) return '';
  return formatTime(value);
}

export function cityName(city) {
  return city?.name || city?.nombreCiudad || '';
}

export function hotelPlaceLabel(hotel) {
  const city = hotel?.hotel?.city || hotel?.city;
  const name = city?.name || '';
  const country = city?.countryName || city?.country?.name || '';
  return [name, country].filter(Boolean).join(', ');
}

export function hotelCategoryLabel(category) {
  if (!category && category !== 0) return '';
  const text = String(category);
  return text.includes('★') ? text : `${text} ★`;
}

export function hotelImageUrls(hotel) {
  return (hotel?.hotelImagenes || []).map((image) => image.imageUrl || image).filter(Boolean);
}

export const DEFAULT_TARIFF_NOTE = (currencyCode) =>
  `PARA TARIFAS EXPRESADAS EN ${currencyCode}. EN CASO DE ABONAR EN PESOS (ARS) SE APLICARÁ EL TIPO DE CAMBIO CORRESPONDIENTE AL DÍA DE PAGO, Y SE ADICIONARÁ LA PERCEPCIÓN CORRESPONDIENTE (RG 4815).`;

export function tariffTaxAmount(price) {
  return Number(price?.taxFree || 0)
}

export function tariffTotalAmount(price) {
  const amount = Number(price?.amount || 0)
  const tax = tariffTaxAmount(price)
  if (tax) return amount + tax
  return Number(price?.totalAmount || amount)
}

export function tariffCurrencyCode(precio, fallback = 'USD', currencyById) {
  const mapped =
    currencyById?.[precio?.currencyId] || currencyById?.[String(precio?.currencyId)];
  return mapped || precio?.currency?.codigo || precio?.currency?.code || fallback;
}
